import { combineReducers } from 'redux';
// Entities
import notification from 'Redux/modules/notification/reducer';

import entities from './modules/entities/reducer';
// Modules
import ui from './modules/ui/reducer';
import lab from './modules/lab/reducer';
import auth from './modules/auth/reducer';
import accountManagement from './modules/accountManagement/reducer';
import files from './modules/files/reducer';
import clinics from './modules/clinics/reducer';
import emr from './modules/emr/reducer';
import patients from './modules/patient/reducer';
import doctors from './modules/doctor/reducer';
import modal from './modules/modal/reducer';
// Web Chat
import webChat from './modules/webChat/reducer';
import search from './modules/search/reducer';
import marketplace from './modules/marketplace/reducer';
import bpdata from './modules/bpdata/reducer';
import contextMenu from './modules/contextMenu/reducer';
import timeslot from './modules/timeslot/reducer';
import appointment from './modules/appointment/reducer';
import invoice from './modules/invoice/reducer';
import report from './modules/report/reducer';
import config from './modules/config/reducer';
import ai from './modules/ai/reducer';
import { AUTH_LOGOUT } from './modules/auth/types';

const appReducer = combineReducers({
  // Authentication
  auth,
  // Normalizr entities
  entities,
  // Modules
  accountManagement,
  ui,
  lab,
  webChat,
  search,
  modal,
  files,
  clinics,
  emr,
  patients,
  notification,
  bpdata,
  doctors,
  contextMenu,
  timeslot,
  appointment,
  invoice,
  report,
  marketplace,
  config,
  ai,
});

const rootReducer = (state, action) => {
  if (action.type === AUTH_LOGOUT) {
    // Set undefined will help us reset the state of Redux
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
